<template>
  <app-modal v-model="isDialogOpened"
             size="md"
             :ok-text="$t('common.delete')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.list.SigningChecklistDeleteTitleDialog.title') }}</template>

    <template #body>{{ $t('project.signing-checklist.list.SigningChecklistDeleteTitleDialog.body') }}</template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistDeleteTitleDialog',
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
